import React from 'react'
import { connect } from 'react-redux';

import { Button, Header, Image, Modal } from 'semantic-ui-react'

import { AnalyticsActions, AnalyticsSelectors } from '../../modules/analytics';

import { ConfigSelectors } from '../../modules/config';

const { getSelectorConfig } = ConfigSelectors;

const { selectDate } = AnalyticsActions;
const { getSelectorFilters } = AnalyticsSelectors;

// <div className="ui small text loader">Loading</div>

class LoadingModal extends React.Component {

    constructor() {
        super()
        this.state = { isLoading: false };
    }
    componentDidMount() {
        this.setState({
            isLoading: true,
        })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.loading) {
            this.setState({ isLoading: true });
        } else {
            this.setState({ isLoading: false });
        }
    }

    render() {
        console.log('LOADING MODAL : loading state ', this.state.isLoading)
        return (
            <Modal
                // open={this.props.loading}
                open={this.state.isLoading}
                basic
                dimmer={'blurring'}
                size={'large'}
                animation={'fade'}
                style={styles.modalContainer}
            >
                <Modal.Content>
                    {/* <div className="ui center aligned grid"> */}
                    <Image className="ui center small circular image spin-image" wrapped src='/loader.png' />
                    {/* </div> */}
                </Modal.Content>
            </Modal>
        )
    }
}

const styles = {
    modalContainer: {
        position: 'absolute',
        top: '50%',
        bottom: 0,
        left: 0,
        right: 0,
        margin: '-80px auto',
        width: 160,
        height: 160,
    }
}


const mapStateToProps = state => {
    return getSelectorConfig(state);
}


export default connect(mapStateToProps, {})(LoadingModal)



// WEBPACK FOOTER //
// ./src/components/LoadingModal/index.js